module.exports = __webpack_public_path__ + "8d0537a3a386796b3e61002a161e4a3f.fbx";